import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeInstanceDebtorPaymentTypes = async ({
    token,
}) => {

    try {
        const res = await axiosCreate.get('/charge/instance/debtor/payment/type', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}